import { Checkbox } from "primereact/checkbox";
import { useMapURLParams } from "../../../../../../hooks/map/useMapParams";
import { useMapSlice } from "../../../../../../stateManagement/hooks/useMapSlice";
import { MapName } from "../../../../../../stateManagement/reducers/maps/actions";
import { MapListRadioFilter } from "../types";
import { useMapDispatch } from "../../../../../../stateManagement/hooks/useMapDispatch";
import { classNames } from "primereact/utils";
import SmallLoader from "../../../../../loaders/SmallLoader";
import { patchFilterListRadioState } from "./filterListRadioFunctions";
import { RadioButton } from "primereact/radiobutton";

type FilterListRadioProps = {
    filterConfig: MapListRadioFilter
}

const captionFilter = (caption: string, searchValue: string) => caption?.toLowerCase().includes(searchValue.toLowerCase())

export default function FilterListRadio({ filterConfig }: FilterListRadioProps) {
    const dispatchMap = useMapDispatch()
    const { canBeIgnored, canIncludeNull, fieldName, hasSearch, preset } = filterConfig ?? {}
    const { mapName } = useMapURLParams() as { mapName: MapName; mapOption?: string };;
    const mapState = useMapSlice(mapName)
    const { mapFiltersState }: any = mapState ?? {};
    const filterState = mapFiltersState?.[fieldName]
    const { isIgnored, includeNull, values, searchValue } = filterState ?? {}
    const ignoreInputId = `ignore-${fieldName}`
    const nullInputId = `null-${fieldName}`

    const listRadioContainerClassNames = classNames({
        "list-radio": true,
        "with-search-container": hasSearch,
        "filter-ignore": isIgnored
    })

    const showNullInput =
        canIncludeNull &&
        (!hasSearch || captionFilter('Не указан', searchValue));

    const visibleValues = hasSearch
        ? values?.filter((valueObj: any) => captionFilter(valueObj.caption, searchValue))
        : values;

    const IsIgnoredValueCheckbox = () => (
        <div className="map-hint-filters-checkbox-div">
            <Checkbox
                inputId={ignoreInputId}
                name={ignoreInputId}
                onChange={(event: any) => patchFilterListRadioState(mapName, fieldName, { isIgnored: event.checked }, dispatchMap)}
                checked={isIgnored}
            />
            <label htmlFor={ignoreInputId} className="ms-2">Не учитывать</label>
        </div>
    )

    const IncludeNullValueCheckbox = () => (
        <div className="map-hint-filters-checkbox-div">
            <Checkbox
                inputId={nullInputId}
                name={nullInputId}
                onChange={(event: any) => patchFilterListRadioState(mapName, fieldName, { includeNull: event.checked }, dispatchMap)}
                checked={includeNull}
            />
            <label htmlFor={nullInputId} className="ms-2">Не указан</label>
        </div>
    )

    return (
        <div className="filter-list-radio">
            {hasSearch && canBeIgnored && <IsIgnoredValueCheckbox />}
            {hasSearch &&
                <input
                    onChange={(e: any) => patchFilterListRadioState(mapName, fieldName, { searchValue: e.target.value }, dispatchMap)}
                    value={searchValue}
                    className="list-radio-search"
                />
            }
            <div className={listRadioContainerClassNames}>
                {hasSearch && showNullInput && <IncludeNullValueCheckbox />}
                {visibleValues
                    ?
                    <>
                        {visibleValues?.map((valueObject: any) => {
                            const { caption, value, checked, color } = valueObject ?? {}
                            const valueInputId = `${value}`
                            return (
                                <div className="map-hint-filters-radio-button-div" style={{ '--radio-button-color': color } as React.CSSProperties}>
                                    <RadioButton
                                        inputId={valueInputId}
                                        name={valueInputId}
                                        value={value}
                                        onChange={(event) => patchFilterListRadioState(mapName, fieldName, { toggleValue: { value, checked: event.checked } }, dispatchMap)}
                                        checked={checked}
                                    />
                                    <label htmlFor={valueInputId} className="ms-2">{caption}</label>
                                </div>
                            )
                        })}
                        {!hasSearch && showNullInput && <IncludeNullValueCheckbox />}
                        {!hasSearch && canBeIgnored && <IsIgnoredValueCheckbox />}
                    </>
                    :
                    <div className="map-hint-filters-checkbox-div">
                        <SmallLoader />
                    </div>
                }
                {visibleValues.length === 0 && !showNullInput &&
                    <div className="map-hint-filters-checkbox-div">
                        <label className="no-results">Нет результатов</label>
                    </div>
                }
            </div>
        </div>
    )
}
